import { render, staticRenderFns } from "./itemFilteredByUsersDialog.vue?vue&type=template&id=60b7a22c"
import script from "./itemFilteredByUsersDialog.vue?vue&type=script&lang=js"
export * from "./itemFilteredByUsersDialog.vue?vue&type=script&lang=js"
import style0 from "./itemFilteredByUsersDialog.vue?vue&type=style&index=0&id=60b7a22c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports